import { render, staticRenderFns } from "./SideFunctionMenu.vue?vue&type=template&id=a33aa02a&scoped=true&"
import script from "./SideFunctionMenu.vue?vue&type=script&lang=js&"
export * from "./SideFunctionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33aa02a",
  null
  
)

export default component.exports